import { RecruitingDashboardEffects } from './recruiting-dashboard.effects';
import { DealsEffects } from './deals.effects';
import { DealsDetailsEffects } from './deal-details.effects';
import { DirectOfferImportMarginEffects } from './direct-offer-import-margin.effects';

export const recruitingEffects = [
    RecruitingDashboardEffects,
    DealsEffects,
    DealsDetailsEffects,
    DirectOfferImportMarginEffects
];
